export const ResumePage = () => {
  return <h1>ResumePage</h1>;
};
